import React, {useEffect, useState} from 'react';
import {connect, useDispatch} from 'react-redux';
import PopUpWithBenefit from './PopupWithBenefit';
import PopUpWithoutBenefit from './PopupWithoutBenefit';
import PopUp from '../../Shared/Popup/PopUp';
import {PopUpTypeEnum, TypeEnum} from './PopUpBenefitEnum';
import {
  getBenefit,
  updateContactAndAccountDetailsPopUpOnly,
  setIsShowPopup,
  resetBlock,
  reportPopUpShow,
  reportPopUpAction,
  setProgressType,
  setIsPrepared,
  setPopUpType,
  setBenefitBlockContent,
} from './BenefitSlice';
import {getReportParams, report} from '../../../middleware/report';

const PopUpBenefitMain = (props) => {
  const dispatch = useDispatch();
  let blockId = props.iContent.contentLink.id;

  const [isAlwaysShowPopUp, setAlwaysShowPopUp] = useState(
    props.iContent.allwaysShowPopUp?.value != undefined && props.iContent.allwaysShowPopUp?.value ? true : false,
  );

  useEffect(() => {
    props.setBenefitBlockContent(blockId);
  }, []);

  useEffect(() => {
    if ((props.isReady && props.isShowPopup) || isAlwaysShowPopUp) {
      dispatch(updateContactAndAccountDetailsPopUpOnly());
      prepare();
    }
  }, [props.isReady]);

  const onClose = (actionType) => {
    props.setIsShowPopup(false);
    setAlwaysShowPopUp(false);
    if (actionType != undefined && actionType != null && typeof actionType === 'string' && actionType != '') {
      props.reportPopUpAction(actionType);
    }
    setTimeout(() => {
      props.resetBlock();
    }, 200);
  };

  const onNavigate = (e) => {
    onClose(e);
    setTimeout(() => {
      props.resetBlock();
      props.context.navigateTo(props.iContent.progressLink?.value);
    }, 200);
  };

  function prepare() {
    //Prepare data
    let isReadyForReport = false;
    let isBenefitPopUp = props.isAllowBenefit;
    let isAlreadyUsedBenefitPopUp = props.isAlreadyUsedBenefit;
    let isOutOfStockBenefitPopUp = false;

    let arrayState = [isBenefitPopUp, isAlreadyUsedBenefitPopUp, isOutOfStockBenefitPopUp];
    switch (arrayState.toString()) {
      case TypeEnum.WithBenefit:
        props.setPopUpType(PopUpTypeEnum.WithBenefit);
        break;
      default:
        props.setPopUpType(PopUpTypeEnum.WithOutBenefit);
        break;
    }
    props.setIsPrepared(true);
    isReadyForReport = true;

    if (isReadyForReport) {
      generateReport();
      props.reportPopUpShow();
    }
  }

  function generateReport() {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Personal Info Update';
    reportParams.channel = 'WebsitePrivate';
    reportParams.status = 'Ongoing';
    reportParams.customerName = props.customerName;
    reportParams.subscriber = '';
    reportParams.idNumber = props.contactId;
    reportParams.param1 = props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCESS' : "ISN'T BENEFIT PROCESS";
    reportParams.param3 = '';
    reportParams.actionType = 'Display PopUp to Update Info';
    reportParams.messageText = 'Displayed PopUp to Update Info';

    switch (props.popUpType) {
      case PopUpTypeEnum.WithBenefit:
        reportParams.actionType = 'Display PopUp to Update Info';
        reportParams.messageText = 'Displayed PopUp to Update Info';
        reportParams.param2 = 'CUSTOMER IS BENEFIT ELIGIBLE';
        reportParams.param4 = 'BENEFIT IS AVAILABLE';
        break;
      case PopUpTypeEnum.WithOutBenefit:
        reportParams.actionType = 'Display PopUp to Update Info';
        reportParams.messageText = 'Displayed PopUp to Update Info';
        reportParams.param2 = "CUSTOMER ISN'T BENEFIT ELIGIBLE";
        reportParams.param4 = "BENEFIT ISN'T AVAILABLE";
        break;
    }
    report(reportParams);
  }

  const submitBottonOnPopupContactDetailsReport = {
    customerName: props.customerName,
    contactId: props.contactId,
    param1: props.iContent.offerBenefit?.value ? 'IS BENEFIT PROCESS' : "ISN'T BENEFIT PROCESS",
  };

  const PopUpComponent = () => {
    switch (props.popUpType) {
      case PopUpTypeEnum.WithBenefit:
        return (
          <>
            <PopUpWithBenefit
              onNavigate={onNavigate}
              onClose={onClose}
              dwhDetails={submitBottonOnPopupContactDetailsReport}
              param2={'CUSTOMER IS BENEFIT ELIGIBLE'}
              benefitButtonText={props.iContent.linkButtonText?.value}
              benefitSecondButtonText={props.iContent.closePopUpText?.value}>
              <h1 className='benefitSubject'>{props.iContent.subjectBenefit?.value}</h1>
              <span className='benefitSecondHeader'>{props.iContent.text?.value}</span>
              <span className='benefitBodyText' dangerouslySetInnerHTML={{__html: props.iContent.textBenefit?.value}}></span>
            </PopUpWithBenefit>
          </>
        );
      case PopUpTypeEnum.WithOutBenefit:
        return (
          <>
            <PopUpWithoutBenefit
              onNavigate={onNavigate}
              onClose={onClose}
              dwhDetails={submitBottonOnPopupContactDetailsReport}
              param2={"CUSTOMER ISN'T BENEFIT ELIGIBLE"}
              benefitButtonText={props.iContent.linkButtonText?.value}
              benefitSecondButtonText={props.iContent.closePopUpText?.value}>
              <h1 className='benefitSubject'>{props.iContent.subjectBenefit?.value}</h1>
              <span className='benefitSecondHeader'>{props.iContent.text?.value}</span>
            </PopUpWithoutBenefit>
          </>
        );
    }
  };

  return (
    <div className='popUpContainer'>
      {props.isPrepared ? (
        <PopUp onClose={onClose} preventWrapperClose={true} showPopUp={props.isShowPopUp || isAlwaysShowPopUp}>
          <PopUpComponent />
        </PopUp>
      ) : (
        ''
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isShowPopUp: state.popupBenefitBlock.isShowPopup,
  isAllowBenefit: state.popupBenefitBlock.isAllowBenefit,
  isAlreadyUsedBenefit: state.popupBenefitBlock.isAlreadyUsedBenefit,
  isPrepared: state.popupBenefitBlock.isPrepared,
  isReady: state.popupBenefitBlock.isReady,
  isShowPopup: state.popupBenefitBlock.isShowPopup,
  contactId: state.authentication.loginData.userDetails.IDNumber,
  customerName: state.authentication.loginData.userDetails.firstName + ' ' + state.authentication.loginData.userDetails.lastName,
  isBenefitOutOfStock: state.popupBenefitBlock.isBenefitOutOfStock,
  popUpType: state.popupBenefitBlock.popUpBenefit.popUpType,
  progressType: state.popupBenefitBlock.popUpBenefit.progressTypeֳ,
});

const mapDispatchToProps = {
  getBenefit,
  updateContactAndAccountDetailsPopUpOnly,
  setIsShowPopup,
  resetBlock,
  reportPopUpShow,
  reportPopUpAction,
  setProgressType,
  setIsPrepared,
  setPopUpType,
  setBenefitBlockContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(PopUpBenefitMain);
